import { Box, Tooltip } from "@mui/material";
import { DateComponent, DateVariant } from "components/base/DateComponent";

export default function RateValidityDate({ date }: { date: DateTime }) {
  return (
    <Tooltip
      arrow
      describeChild
      title={
        <Box
          component="dl"
          sx={{
            display: "grid",
            gridTemplateColumns: "auto minmax(0, 1fr)",
            columnGap: 1.5,
            rowGap: 0.5,
            m: 0,
            "& dt": { fontWeight: 600 },
            "& dd": { m: 0 }
          }}
        >
          <dt>UTC</dt>
          <dd>
            <DateComponent date={date} variant={DateVariant.DETAILED} />
          </dd>
          <dt>Local</dt>
          <dd>
            <DateComponent date={date} variant={DateVariant.DETAILED_LOCAL} />
          </dd>
        </Box>
      }
    >
      <span>
        <DateComponent date={date} variant={DateVariant.SHORT_UTC} />
      </span>
    </Tooltip>
  );
}